import React, { Fragment, useContext, useEffect, useState } from "react";
import { AppContext } from "../../../components/AppProvider";
import { PostApi1604 } from "../../../modules/network/padoPost";
import { _O } from "../../../modules/utils";
import { NativeAction } from "../../../modules/utils/HandleWs";
import { userHabit } from "../../../modules/utils/UserHabit";
import { reLogin } from "../../common/AutoLogin/AutoLogin";
import { Container } from "../../Layout";
import { circulatePrice, PayInfo } from "./ProofPay";

export default props => {
  const { userinfo, cfg, phonecfg, auth, dispatch } = useContext(AppContext);

  useEffect(() => {
    userHabit(phonecfg, "PF023");
    NativeAction(phonecfg, "statusColor", "#b2bee6");
  }, [phonecfg.version]);

  return (
    <Fragment>
      {props.match.params.resCd === "DTL" ? (
        <ProofDetail
          seqNo={props.match.params.seqNo}
          resCd={props.match.params.resCd}
          resMsg={props.match.params.resMsg}
          userToken={props.match.params.userToken}
        />
      ) : (
        <ProofResult
          seqNo={props.match.params.seqNo}
          resCd={props.match.params.resCd}
          resMsg={props.match.params.resMsg}
          userToken={props.match.params.userToken}
        />
      )}
    </Fragment>
  );
};

const ProofResult = props => {
  const { userinfo, cfg, phonecfg, auth, dispatch } = useContext(AppContext);
  const [payList, setPayList] = useState();
  const [prodNm, setProdNm] = useState("");

  const [totalPrice, setTotalPrice] = useState();
  const { seqNo, resCd, resMsg, userToken } = props;

  // props.match.params
  const request1604 = (userToken, seqNo, prodType) => {
    PostApi1604(userToken, cfg, phonecfg, seqNo, prodType)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          // _O.Open("/proof/payment");
          setPayList(res.result);
          circulatePrice(res.result, setTotalPrice);

          if (res.result.length - 1 > 1) {
            setProdNm(
              res.result[0].prodDesc + " 외 " + (res.result.length - 1) + "건"
            );
          } else {
            setProdNm(res.result[0].prodDesc);
          }
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  let userinfo2 = reLogin(auth, userinfo, dispatch);

  const endPayment = () => {
    window.parent.location.href = "/#/pmr/proofList/3/1/1";
  };

  useEffect(() => {
    if (resCd == "W002") {
      request1604(userToken, seqNo, "C");
    } else {
      request1604(userToken, seqNo, "H");
    }
  }, []);

  return (
    <div className="sub-contents">
      <div className="sub-title">
        {/* 5. */}
        {resCd == "0000"
          ? " 결제성공"
          : resCd == "DTL"
          ? " 결제상세"
          : resCd == "W002"
          ? " 결제취소"
          : " 결제실패"}
      </div>
      <div className="device-state-info res">
        {resCd == "DTL" ? resMsg : decodeURIComponent(resMsg)}
      </div>

      {payList && (
        <PayInfo resultCd={resCd} payList={payList} totalPrice={totalPrice} />
      )}
      <div
        className="under-fix-btnarea"
        style={{
          borderBottom: "1px solid #fff",
          position: "relative",
          bottom: "0px",
        }}>
        {/* <a className="agbtn" onClick={() => _O.Open("/proof/storage/3/1/1")}><i className="app"></i>확인</a> */}
        <a className="agbtn" onClick={() => endPayment()}>
          <i className="app"></i>확인
        </a>
      </div>
    </div>
  );
};

const ProofDetail = props => {
  const { userinfo, cfg, phonecfg, auth, dispatch } = useContext(AppContext);
  const [payList, setPayList] = useState();
  const [prodNm, setProdNm] = useState("");

  const [totalPrice, setTotalPrice] = useState();

  const { seqNo, resCd, resMsg, userToken } = props;

  // props.match.params
  const request1604 = (userToken, seqNo, prodType) => {
    PostApi1604(userToken, cfg, phonecfg, seqNo, prodType)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          // _O.Open("/proof/payment");
          setPayList(res.result);
          circulatePrice(res.result, setTotalPrice);

          if (res.result.length - 1 > 1) {
            setProdNm(
              res.result[0].prodDesc + " 외 " + (res.result.length - 1) + "건"
            );
          } else {
            setProdNm(res.result[0].prodDesc);
          }
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (resCd == "W002") {
      request1604(userToken, seqNo, "C");
    } else {
      request1604(userToken, seqNo, "H");
    }
  }, []);

  return (
    <Container
      Title="결제"
      proof="CLAIM"
      color="purple"
      onClick={() => _O.Open("/pmr/proofList/3/1/1")}>
      <div className="contents sub grad">
        {/* <SubMenu code="APPLY" /> */}

        <div className="sub-contents">
          {resCd != "DTL" && (
            <div className="steps-bar-area">
              <ul>
                <li style={{ width: "33%" }}>
                  <a>STEP 1</a>
                </li>
                <li style={{ width: "33%" }}>
                  <a>STEP 2</a>
                </li>
                <li className="on" style={{ width: "34%" }}>
                  <a>STEP 3</a>
                </li>
              </ul>
            </div>
          )}

          <div className="sub-title">
            {/* 5. */}
            {resCd == "0000"
              ? " 결제성공"
              : resCd == "DTL"
              ? " 결제상세"
              : resCd == "W002"
              ? " 결제취소"
              : " 결제실패"}
          </div>
          <div className="device-state-info res">
            {resCd == "DTL" ? resMsg : decodeURIComponent(resMsg)}
          </div>

          {payList && (
            <PayInfo
              resultCd={resCd}
              payList={payList}
              totalPrice={totalPrice}
            />
          )}
        </div>
      </div>
    </Container>
  );
};
